import { useQuery } from "@tanstack/react-query";
import { getTransactionFees } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const TRANSACTIONS_FEES_QUERY_KEY = "TRANSACTIONS_FEES";

export const getTransactionsFeesQueryKey = (
  dateFrom?: string | null,
  dateTo?: string | null,
) => [TRANSACTIONS_FEES_QUERY_KEY, dateFrom, dateTo];

export const useTransactionsFees = (
  dateFrom?: string | null,
  dateTo?: string | null,
) =>
  useQuery({
    queryKey: getTransactionsFeesQueryKey(dateFrom, dateTo),
    queryFn: processResponseWithApiProblemDetails(() =>
      getTransactionFees(dateFrom, dateTo),
    ),
  });
